<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { putRedis, getRedis } from "@/common/redis";
import { mapState, mapMutations } from "vuex";
export default {
  methods: {
    ...mapMutations(["setUserInfo", "setOpenId"]),
  },
  beforeMount() {
    // let userInfo = getRedis("userInfo");
    // if (userInfo) {
    //   console.log("登录有效", userInfo);
    //   this.setUserInfo(userInfo);
    // }
  },
};
</script>

<style>
#app {
  height: 100%;
}
</style>

